<div
  class="flex justify-content-around flex-wrap h-screen align-content-center">
  <form [formGroup]="forgetForm" (ngSubmit)="onSubmit()">
    <p-card styleClass="w-30rem">
      <ng-template pTemplate="title">
        <i class="fas fa-person-circle-question"></i> Passwort vergessen
      </ng-template>
      <ng-template pTemplate="content">
        @if (sent) {
          <p-messages
            [(value)]="messages"
            [enableService]="false"
            [closable]="false"></p-messages>
        }

        <div class="flex flex-column gap-3">
          <label for="username">Anmeldename</label>
          <input
            type="text"
            id="username"
            formControlName="username"
            pInputText />
        </div>
      </ng-template>
      <ng-template pTemplate="footer">
        <p-button
          [loading]="loading"
          [rounded]="true"
          icon="fas fa-paper-plane"
          label="anfragen"
          type="submit">
        </p-button>
      </ng-template>
    </p-card>
  </form>
</div>
